import { idOrIdentifierSchema } from "@suse-o11y/id-or-identifier";
import { isPresent } from "@suse-o11y/is-present";

import { decodeAllSearchParams } from "../../../app/state/route/SearchParams";
import {
	ANALYTICS_PATH,
	CLIPROFILE_PATH,
	COMPONENT_PATH,
	DASHBOARDS_OVERVIEW_PATH,
	DASHBOARD_PATH,
	KUBERNETES_OVERVIEW_PATH,
	METRICS_PATH,
	MONITORS_PATH,
	NOTIFICATIONS_PATH,
	SETTINGS_PATH,
	STACKPACKS_INTEGRATION_PATH,
	STACKPACKS_PATH,
	STACKPACKS_STACKPACK_PATH,
	TRACES_PATH,
	VIEWS_OVERVIEW_PATH,
	VIEW_PATH,
	WELCOME_PATH,
} from "../../../routes/Routes";
import { type SettingsFragment, settingsFragmentToName } from "../../../routes/settings/SettingsFragment";

import { SmartHistorySchema } from "./SmartHistorySchema";

export type MonitorsPathParams =
	| { type: "overview" }
	| {
			type: "new";
			monitorFunctionIdentifier: undefined | string;
	  }
	| {
			type: "edit";
			monitorId: string;
	  };

export type NotificationsPathParams =
	| { type: "overview" }
	| { type: "new" }
	| {
			type: "edit";
			notificationId: string;
	  };

export const schema = new SmartHistorySchema({
	decodeSearchParams: decodeAllSearchParams,
})
	.route(KUBERNETES_OVERVIEW_PATH)

	.route(VIEWS_OVERVIEW_PATH)
	.route(VIEW_PATH, ({ slug }, { explore }) => ({
		slug,
		isExplore: isPresent(explore),
	}))

	.route(DASHBOARDS_OVERVIEW_PATH)
	.route(DASHBOARD_PATH, ({ idOrIdentifier }) => ({
		idOrIdentifier: idOrIdentifierSchema.parse(idOrIdentifier),
	}))

	.route(COMPONENT_PATH, ({ identifier }, { explore }) => ({
		identifier,
		isExplore: isPresent(explore),
	}))

	.route(METRICS_PATH)

	.route(TRACES_PATH)

	.route(MONITORS_PATH, ({ id, monitorFunctionIdentifier }): MonitorsPathParams => {
		if (id === "new") {
			return {
				type: "new",
				monitorFunctionIdentifier,
			};
		}

		if (id != null) {
			return {
				type: "edit",
				monitorId: id,
			};
		}

		return {
			type: "overview",
		};
	})

	.route(CLIPROFILE_PATH)

	.route(ANALYTICS_PATH)

	.route(SETTINGS_PATH, ({ name, id }) => ({
		name: name == null ? undefined : settingsFragmentToName(name as SettingsFragment),
		id: id == null ? undefined : id === "new" ? "Add" : "Edit",
	}))

	.route(NOTIFICATIONS_PATH, ({ id }): NotificationsPathParams => {
		if (id == null) {
			return { type: "overview" };
		}

		if (id === "new") {
			return { type: "new" };
		}

		return {
			type: "edit",
			notificationId: id,
		};
	})

	.route(STACKPACKS_PATH)

	.route(STACKPACKS_STACKPACK_PATH, ({ name }) => ({
		name,
	}))

	.route(STACKPACKS_INTEGRATION_PATH, ({ name, integration }) => ({
		name,
		integration,
	}))

	.route(WELCOME_PATH);
